import { createSelector } from 'reselect';
import { GONE } from 'http-status';
import { get, flow } from 'lodash/fp';
import { getError } from 'components/page/Layout';

import { STORE_KEY, CMS_KEY } from '../duck';
import getTemplateComponent, { MAIN_SEARCH } from '../getTemplateComponent';

const getCms = get([STORE_KEY, CMS_KEY]);

export const getCmsResult = createSelector(getCms, get(['result']));
export const getCurrentCmsTemplate = createSelector(
  getCms,
  get(['currentTemplate']),
);

export const getCmsRedirect = createSelector(
  getCmsResult,
  get(['redirect-to']),
);

const getCmsError = createSelector(getCms, get(['error']));

export const layoutErorStatusCodeSelector = createSelector(
  getCmsError,
  flow(get(['statusCode']), getError),
);

export const getCmsTemplate = createSelector(
  [getCmsResult, layoutErorStatusCodeSelector],
  (result, statusCode) => {
    const template = get(['template'], result);

    if (statusCode && statusCode.code === GONE) {
      return MAIN_SEARCH;
    }

    return template;
  },
);

export const cmsTemplateComponentSelector = createSelector(
  getCmsTemplate,
  getTemplateComponent,
);
